module.exports = __webpack_public_path__ + "img/white-loading.2f25bd5b.jpg";